<template>
    <div class="login">
        <v-layout row wrap class="login-content">
            <v-flex md5 class="login-form">
                <v-form v-model="valid">
                    <div class="login-desc">
                        <h1>Sign In to <br>
                            your account
                        </h1>
                        <p>Don’t have an account? <span class="pointer" @click="toSignUp">Sign Up</span></p>
                    </div>
                    <v-form v-model="valid" ref="form" class="mt-5">
                        <Label>Enter your email address</Label>
                        <v-text-field
                                outline
                                v-model="username"
                                name="login"
                                placeholder="EMail"
                                type="text"
                                flat
                                :rules="[v => !!v || 'Email or user name is required']"
                        ></v-text-field>
                        <label>Enter Password</label>
                        <v-text-field
                                outline
                                :append-icon="!showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="showPassword ? 'text' : 'password'"
                                @click:append="showPassword = !showPassword"
                                v-model="password"
                                name="password"
                                placeholder="Password"
                                :rules="[v => !!v || 'Password is required']"
                        ></v-text-field>
                        <v-btn @click="login" block large round :loading="loading" color="primary">Sign In</v-btn>
                        <v-btn block large round flat color="secondary" to="/forget-password/">Forget Password?</v-btn>
                    </v-form>
                    <div v-if="wrongCredentials === true" class="text-xs-center white--text">Invalid User Name or
                        Password
                    </div>
                </v-form>
            </v-flex>
            <v-flex md5 offset-md2 class="pa-0">
                <img src="../assets/img/login-img.png" class="login-img" alt="login"/>
            </v-flex>
        </v-layout>

    </div>
</template>

<script>
    export default {
        data: () => ({
            username: '',
            password: '',
            valid: true,
            wrongCredentials: false,
            showPassword: false,
            loading: false
        }),
        methods: {
            login() {
                this.loading = true
                if (this.$refs.form.validate()) {
                    const store = this.$store;
                    this.$http_noauth.post('/auth/login', {
                        email: this.username,
                        password: this.password
                    })
                        .then(response => {
                            store.dispatch('setUserToken', response.data.token)
                            store.dispatch('setUserData', response.data.user)
                            store.dispatch('setRoleId', response.data.user.role_id)
                            localStorage.setItem('userToken', response.data.token)
                            localStorage.setItem('userData', JSON.stringify(response.data.user))
                            localStorage.setItem('roleId', JSON.stringify(response.data.user.role_id))
                            window.location.href = "/"
                            this.loading = false
                        })
                        .catch(error => {
                            this.wrongCredentials = true
                            this.loading = false
                        });
                }
            },
            toSignUp(ev) {
                console.log(ev)
                this.$router.push({name: 'signup'})
            }

        }
    }
</script>
<style scoped>
    body {
        height: 100vh !important;
        overflow: hidden;
    }
</style>
